import React, { useState } from 'react';
import { ButtonField, InputField } from '@wk/components-react16';
import { Formik, Form } from 'formik';
import * as yup from 'yup';
import { API_USER } from '../../core/constants';
import Api from '../../core/api';
import { Auth, Toast } from "../../services"

const ChangePassword = () => {
    const user = Auth.getUserame();
    const Schema = yup.object().shape({
        oldPassword: yup
            .string()
            .required('Please enter your current password.'),
        password: yup
            .string()
            .required('Please enter your new password.')
            .min(8, 'Password must be 8 characters long')
            .matches(/[0-9]/, 'Password must contain at least one number')
            .matches(/[a-z]/, 'Password must contain at least lowercase letter')
            .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
            .matches(/[^\w]/, 'Password must contain at least one special character')
            //.matches(/[(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s])]/, 'Password must contain at least one uppercase, one lowercase, one number and one special character.')
            .notOneOf([yup.ref('oldPassword')], 'New password shouldn\'t be same.'),
        confirmPassword: yup
            .string()
            .required('Please confirm your new password.')
            .oneOf([yup.ref('password')], 'Confirm password must match with new password.'),
    });

    const submit = async (values: any, { resetForm }: any) => {
        Api.putRequest(API_USER.CHANGE_PASSWORD, values).then(
            (res: any) => {
                if (res.status === 200) Toast("New password is successfully updated.", "sucsess");
                else Toast(res.message, "sucsess");
                resetForm();
            },
            (err: any) => {
                Toast(err.message, "error");
            },
        )
    }

    return (
        <section className="wk-card-container wk-card-container-v-dividers">
            <header className="wk-card-container-header">
                <h6>Change Password</h6>
            </header>
            <div className="wk-card-container-body">
                <div className="wk-card-container-body-cell w-6">
                    <Formik
                        validationSchema={Schema}
                        enableReinitialize={true}
                        initialValues={{ username: user, oldPassword: "", password: "", confirmPassword: "" }}
                        onSubmit={submit} resetForm
                    >
                        {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isValid,
                            dirty, }) => (

                            <Form onSubmit={handleSubmit}>
                                <div className="wk-row">
                                    <div className="wk-col-12">
                                        <InputField
                                            label="Username"
                                            labelFor="username-1"
                                            size="small" indicator="required">
                                            <input
                                                type="text"
                                                id="username-1"
                                                name="username"
                                                readOnly
                                                value={values.username}
                                                disabled
                                            />
                                        </InputField>
                                        <InputField
                                            label="Old Password"
                                            labelFor="oldPassword-1"
                                            size="small" indicator="required"
                                            status={!!errors.oldPassword ? "error" : "none"}
                                            errors={!!errors.oldPassword ? [{
                                                label: errors.oldPassword,
                                                labelId: 'label-error-id-1',
                                            }] : []}>
                                            <input
                                                type="password"
                                                id="oldPassword-1"
                                                name="oldPassword"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.oldPassword}
                                                placeholder="Enter current password"
                                                autoComplete="off"
                                            />
                                        </InputField>
                                        <InputField
                                            label="New password"
                                            labelFor="password-1"
                                            size="small" indicator="required"
                                            status={!!errors.password ? "error" : "none"}
                                            errors={!!errors.password ? [{
                                                label: errors.password,
                                                labelId: 'label-error-id-2',
                                            }] : []}>
                                            <input
                                                type="password"
                                                id="password-1"
                                                name="password"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.password}
                                                placeholder="Enter new password"
                                                autoComplete="off"
                                            />
                                        </InputField>
                                        <InputField
                                            label="Confirm Password"
                                            labelFor="confirmPassword-1"
                                            size="small" indicator="required"
                                            status={!!errors.confirmPassword ? "error" : "none"}
                                            errors={!!errors.confirmPassword ? [{
                                                label: errors.confirmPassword,
                                                labelId: 'label-error-id-3',
                                            }] : []}>
                                            <input
                                                type="password"
                                                id="confirmPassword-1"
                                                name="confirmPassword"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.confirmPassword}
                                                placeholder="Enter confirm password"
                                                autoComplete="off"
                                            />
                                        </InputField>
                                        <div className="wk-row">
                                            <div className="wk-col-12 text-right">
                                                <ButtonField size={'small'}>
                                                    <button type="submit" disabled={!(isValid)}>
                                                        Submit
                                                    </button>
                                                </ButtonField>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
                <div className="wk-card-container-body-cell w-6">
                    <div className='mb-3'>
                        <strong>Instructions:</strong>
                        <div>Password must be at least 8
                            characters long</div>
                        <div>Your password must contain at least</div>
                        <div> - one uppercase</div>
                        <div> - one lowercase</div>
                        <div> - one number</div>
                        <div> - one special character</div>
                    </div>
                </div>
            </div>
        </section >
    );
};

export default ChangePassword;
